/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_NoneInputs */

const en_subtitle_export_none = /** @type {(inputs: Subtitle_Export_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None`)
};

const fr_subtitle_export_none = /** @type {(inputs: Subtitle_Export_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun`)
};

const de_subtitle_export_none = /** @type {(inputs: Subtitle_Export_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keiner`)
};

const it_subtitle_export_none = /** @type {(inputs: Subtitle_Export_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuno`)
};

const ru_subtitle_export_none = /** @type {(inputs: Subtitle_Export_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Никто`)
};

const es_subtitle_export_none = /** @type {(inputs: Subtitle_Export_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ninguno`)
};

const zh_cn2_subtitle_export_none = /** @type {(inputs: Subtitle_Export_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有任何`)
};

const ja_subtitle_export_none = /** @type {(inputs: Subtitle_Export_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なし`)
};

const hi_subtitle_export_none = /** @type {(inputs: Subtitle_Export_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई नहीं`)
};

const pt_pt2_subtitle_export_none = /** @type {(inputs: Subtitle_Export_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum`)
};

/**
* | output |
* | --- |
* | "None" |
*
* @param {Subtitle_Export_NoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_none = /** @type {((inputs?: Subtitle_Export_NoneInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_NoneInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_none(inputs)
	if (locale === "de") return de_subtitle_export_none(inputs)
	if (locale === "it") return it_subtitle_export_none(inputs)
	if (locale === "ru") return ru_subtitle_export_none(inputs)
	if (locale === "es") return es_subtitle_export_none(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_none(inputs)
	if (locale === "ja") return ja_subtitle_export_none(inputs)
	if (locale === "hi") return hi_subtitle_export_none(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_none(inputs)
	return en_subtitle_export_none(inputs)
});